module.exports = __webpack_public_path__ + "927f8dee92023a7c2ca14774f16751b8.png";